module.exports = __webpack_public_path__ + "img/lamp-sidebar.c0519ad7.png";